import { useCallCancellablePromise } from 'react-redux-app/lib/modules/core/hooks';
import useHandleErrorOrExecute from './useHandleErrorOrExecute';


export default errorSelector => {
  const callCancellablePromise = useCallCancellablePromise(errorSelector);
  const handleErrorOrExecute = useHandleErrorOrExecute();

  return (
    promise,
    errorDialogHeaderLangKey,
    errorMapWithPageReload = {},
    errorMapWithoutPageReload = {},
    successCallback = null,
    errorCallback = null,
    callback = null
  ) => {
    callCancellablePromise(
      promise,
      error => {
        handleErrorOrExecute(
          error,
          errorDialogHeaderLangKey,
          errorMapWithPageReload,
          errorMapWithoutPageReload,
          successCallback,
          errorCallback,
          callback
        );
      }
    );
  };
};
